<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'

defineProps<{
  multiplicity: number | null
}>()
</script>

<template>
  <div v-if="multiplicity !== null && multiplicity > 1" class="text-main-orange">
    Заказ по&nbsp;{{ multiplicity }}&nbsp;{{ helpers.getDeclension(multiplicity, constants.wordForms.piece) }}
  </div>
</template>
